var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("../assets/logo/logo_transparent.png"),"alt":"Tuin & Meer logo"},on:{"click":function($event){return _vm.refresh()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }